import "core-js/modules/es.regexp.exec.js";
import { ref } from 'vue';
import MobileDetect from 'mobile-detect';
export const useDevice = function () {
  const ua = navigator.userAgent;
  const isMobile = ref(/Mobi|Android|iPhone/i.test(ua));
  isMobile.value = window.innerWidth <= 768;
  const isWeixin = ref(/MicroMessenger/i.test(ua));
  const isAndroid = ref(ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1);
  const isMoyuApp = ref(ua.includes('Hero'));
  const isMac = ref(ua.includes('Mac OS'));
  window.addEventListener('resize', function () {
    isMobile.value = window.innerWidth <= 768;
  });
  const isIOS = function () {
    const {
      userAgent
    } = navigator;
    const {
      platform
    } = navigator;
    const maxTouchPoints = navigator.maxTouchPoints || 0;

    // 判断 iPhone、iPod、iPad
    const iOSDevice = /iPhone|iPod|iPad/i.test(userAgent);

    // iPad 特定的判断，iOS 13+ 的 iPad 可能返回 MacIntel 作为 platform
    const isIpad = platform === 'MacIntel' && maxTouchPoints > 1;
    return iOSDevice || isIpad;
  };
  const md = new MobileDetect(ua);
  const isMobileReal = ref(!!(md.mobile() || md.tablet() || isIOS()));
  return {
    isMobile,
    isWeixin,
    isAndroid,
    isMoyuApp,
    isMac,
    isMobileReal,
    isIOS
  };
};